import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MAX_SELECTIONS } from '../../../constants/defaults';
import { IBullhornEntity } from '../../../types/bullhorn/bullhorn-entity';

@Component({
    selector: 'app-multi-entity-select',
    templateUrl: './multi-entity-select.component.html',
    styleUrls: ['./multi-entity-select.component.scss'],
    standalone: false
})
export class MultiEntitySelectComponent implements OnInit {
  @Input() candidatesLabel!: string;
  @Input() jobSubmissionLabel!: string;
  @Input() entities!: IBullhornEntity[];
  @Input() chosenEntities!: IBullhornEntity[];
  @Output() entitiesSelected: EventEmitter<{ entitiesSelected: IBullhornEntity[] }> = new EventEmitter();

  statusControl = new FormControl();
  filteredEntities = new BehaviorSubject<IBullhornEntity[]>([]);
  readonly MAX_SELECTIONS = MAX_SELECTIONS;

  constructor(
  ) {}

  ngOnInit() {
    this.statusControl.valueChanges
      .pipe(
        startWith(''),
        map((statuses: string[]) =>
          statuses
            ? this.entities.filter((entity) => statuses.includes(entity.status ?? ''))
            : this.entities.slice(),
        ),
      )
      .subscribe((filtered) => {
        this.filteredEntities.next(filtered);
        this.chosenEntities = [];
      });

    this.statusControl.patchValue(this.statuses);
  }

  protected emitSelectedEntites(): void {
    this.entitiesSelected.emit({ entitiesSelected: this.chosenEntities });
  }

  get statuses() {
    return [...new Set(this.entities.map((entity) => entity.status))];
  }

}
